import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const RsvtiOperatorsReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                rsvtiOperators:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.RSVTI_OPERATORS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, rsvtiOperators: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_RSVTI_OPERATORS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, rsvtiOperators: action.payload};

        case ActionTypes.RSVTI_OPERATORS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_RSVTI_OPERATOR:
            const nOperator = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, rsvtiOperators: state.rsvtiOperators.concat(nOperator)};
    
        case ActionTypes.UPDATE_RSVTI_OPERATOR:
            const uOperator = action.payload;
            const updatedOperators = state.rsvtiOperators.map(e => e.id === uOperator.id ? uOperator : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, rsvtiOperators: updatedOperators};

        default:
            return state;
    }
};